import { useEffect } from "react";

import { countryKeyFromOrg } from "@/lib/countryProfile";
import { setActiveOrgFormat } from "@/lib/orgFormat";
import { useAuth } from "@/hooks/useAuth";

/** Keep number/currency/timezone formatters aligned with the active organization, not the UI language. */
export function OrgFormatSync(): null {
  const { user } = useAuth();
  const currency = user?.organization?.currency ?? null;
  const countryKey = countryKeyFromOrg(user?.organization ?? null);
  const timeZone = user?.organization?.timeZone ?? null;

  useEffect(() => {
    setActiveOrgFormat({
      currency,
      countryKey: user?.organization ? countryKey : null,
      timeZone: user?.organization ? timeZone : null,
    });
    return () => {
      setActiveOrgFormat({ currency: null, countryKey: null, timeZone: null });
    };
  }, [currency, countryKey, timeZone, user?.organization]);

  return null;
}
